module.exports = __webpack_public_path__ + "dist/assets/img/header_about.75d42efa.jpg";